export {default as drag} from "./src/drag";
export {default as dragDisable, yesdrag as dragEnable} from "./src/nodrag";



//////////////////
// WEBPACK FOOTER
// ./~/vue-d3/~/d3-drag/index.js
// module id = cxl5
// module chunks = 0